<div class="selectable-list-content-container">
  <ng-content></ng-content>
</div>
